import { BaitStates } from '../constants/BaitStates';

export class BaitItemOnPlayground {
    #item;
    #i = 0;
    #j = 0;
    #lifeTime = -1;
    #delay = 1;
    #birthTimestamp = -1;
    #eatTimestamp = -1;
    #state = BaitStates.EMPTY;
    #stateChanged = false;
    #action = null;

    constructor(item, { lifeTime, action }, i = 0, j = 0, state = BaitStates.IDLE) {
        this.#i = i;
        this.#j = j;
        this.#item = item;
        this.#lifeTime = lifeTime;
        this.#birthTimestamp = Date.now();
        this.#state = state;
        this.#action = action;
    }

    isAlive(t) {
        if (this.#state === BaitStates.EATEN) {
            if (t - this.#eatTimestamp > this.#delay * 1000) {
                this.#stateChanged = this.#state !== BaitStates.EMPTY;
                this.#state = BaitStates.EMPTY;
            }

            return false;
        }

        if (this.#lifeTime > 0 && t - this.#birthTimestamp > this.#lifeTime * 1000) {
            this.#stateChanged = this.#state !== BaitStates.EMPTY;
            this.#state = BaitStates.EMPTY;

            // The final chance to eat this bait
            return this.#stateChanged;
        }

        return true;
    }

    remove() {
        this.#stateChanged = this.#state !== BaitStates.EMPTY;
        this.#state = BaitStates.EMPTY;

        return this.#stateChanged;
    }

    eat() {
        if (this.#state !== BaitStates.IDLE && !this.#stateChanged) return false;

        this.#eatTimestamp = Date.now();
        this.#stateChanged = true;
        this.#state = BaitStates.EATEN;

        return true;
    }

    get row() {
        return this.#j;
    }

    get col() {
        return this.#i;
    }

    get action() {
        return this.#action;
    }

    get type() {
        return this.#item.type;
    }

    get viewType() {
        return this.#item.viewType;
    }

    get state() {
        return this.#state;
    }

    get changed() {
        return this.#stateChanged;
    }

    resetChanged() {
        this.#stateChanged = false;
    }
}
